// Frontend helpers for survey SMS template preview/validation.
// Keep separate from utils/survey.js (CommonJS) to avoid webpack named/default export interop issues.

export const surveySmsTemplateKeys = ['event_name', 'survey_url', 'program_name', 'organization_name']

export const surveySmsRequiredTemplateKeys = ['event_name', 'survey_url']

export const welcomeSmsDefaultSuffix = 'Complete your [event] assessment by using the link provided below:'

export const reminderSmsDefaultSuffix = 'Complete your [event] assessment by using this link:'

export const surveySmsUrlPlaceholder = '[survey URL]'

export const surveySmsPreviewVariables = {
  event_name: '[Event Name]',
  survey_url: '[Survey URL]',
  program_name: '[Program Name]',
  organization_name: '[Organization Name]'
}

export function normalizeSurveySmsTemplateKey (key = '') {
  return String(key).trim().toLowerCase()
}

export function extractSurveySmsTemplateKeys (body = '') {
  const keys = []
  const pattern = /\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g
  let match

  while ((match = pattern.exec(body)) !== null) {
    keys.push(normalizeSurveySmsTemplateKey(match[1]))
  }

  return keys
}

export function validateSurveySmsTemplate ({body = '', excludeSuffix = false}) {
  const keys = extractSurveySmsTemplateKeys(body)
  const uniqueKeys = [...new Set(keys)]
  const allowed = new Set(surveySmsTemplateKeys)
  const unknown = uniqueKeys.filter(key => !allowed.has(key))
  const errors = []

  if (unknown.length) {
    errors.push(`Unknown template key(s): ${unknown.map(key => `{{${key}}}`).join(', ')}`)
  }

  if (excludeSuffix) {
    const missing = surveySmsRequiredTemplateKeys.filter(key => !uniqueKeys.includes(key))

    if (missing.length) {
      errors.push(`Required when excluding default suffix: ${missing.map(key => `{{${key}}}`).join(', ')}`)
    }
  }

  return {valid: errors.length === 0, errors}
}

export function interpolateSurveySmsTemplate (body = '', variables = {}) {
  return body.replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, (match, key) => {
    const normalizedKey = normalizeSurveySmsTemplateKey(key)

    if (!Object.prototype.hasOwnProperty.call(variables, normalizedKey)) {
      return match
    }

    const value = variables[normalizedKey]

    if (value === null || value === undefined) {
      return ''
    }

    return String(value)
  })
}

export function buildSurveySmsPreview ({
  smsBody = '',
  excludeSuffix = false,
  suffix = '',
  urlPlaceholder = surveySmsUrlPlaceholder
}) {
  const rawBody = (smsBody || '').trim()
  const hasSurveyUrlToken = extractSurveySmsTemplateKeys(rawBody).includes('survey_url')
  const body = interpolateSurveySmsTemplate(rawBody, surveySmsPreviewVariables)

  if (excludeSuffix) {
    if (!hasSurveyUrlToken) {
      return [body, urlPlaceholder].filter(Boolean).join(' ')
    }

    return body
  }

  return [body, suffix, urlPlaceholder].filter(Boolean).join(' ')
}
